<template>
  <el-container id="search-screen" style="align-items: center">
    <el-col class="main-wrapper" :xs="22" :sm="21" :md="20" :lg="19" :xl="18">
      <el-col
      :xs="24"
      :sm="12"
      :md="12"
      :lg="12"
      :xl="11"
      class="left-wrapper">
        <el-form
          ref="form"
          :model="form"
          :rules="rules"
          class="form"
          :disabled="loading || receiptBtnLoading || certificateBtnLoading"
          @keydown.enter.native="noDebtsCertificateSubmit"
          @submit.prevent.native
          @submit="noDebtsCertificateSubmit"
        >
          <h2 class="form-title">
            Realiza tu pago en línea los 365 días del año las 24 hrs.
          </h2>
          <el-form-item prop="accountNumber">
            <label for="accountNumber" class="el-form-item__label">
              <strong class="main"
                >Ingresa tu número de cuenta de predial</strong
              >
              <span class="clue"> Ejemplo: 1114000000 </span>
            </label>
            <el-input v-model="form.accountNumber" maxlength="10" />
          </el-form-item>

          <el-form-item prop="curt">
            <label for="accountNumber" class="el-form-item__label">
              <strong class="main">
                o ingresa tu Clave Única del Registro del Territorio (CURT)
              </strong>
              <span class="clue"> clave de 31 dígitos </span>
            </label>
            <el-input v-model="form.curt" maxlength="31" />
          </el-form-item>
          <el-form-item style="margin-bottom: 15px">
            <el-button
              id="btn-submit"
              type="primary"
              native-type="submit"
              style="display: block; width: 100%"
              @click="noDebtsCertificateSubmit"
              :loading="loading && !receiptBtnLoading && !certificateBtnLoading"
            >
              {{ !loading ? "Certificado de no adeudo" : "Cargando" }}
            </el-button>
          </el-form-item>
        </el-form>
        <br />
        <p class="schedule">
          Dirección de Ingresos
          <br />
          Horarios de atención de las recaudadoras:
          <br />
          Lunes a Viernes de 9:00 am. a 3:00 pm.
        </p>
      </el-col>
      <el-col class="right-wrapper" :xs="24" :sm="11" :md="11" :lg="9" :xl="9">
        <div class="logo">
          <img src="../assets/images/logo-tesoreria.png" alt="logo tesorería" />
        </div>
        <div class="actions-wrapper">
          <!--
            <router-link
            class="el-button el-button--primary"
            type="info"
            tag="a"
            to="requisitos-para-descuentos-especiales"
          >
            Requisitos para descuentos especiales
          </router-link>
          -->
          <a
            v-if="!$isWebView()"
            class="el-button el-button--primary"
            type="info"
            tag="a"
            href="https://www.zapopan.gob.mx/requisitos-para-descuentos-especiales/"
            target="_blank"
          >
            Requisitos para descuentos especiales
          </a>
          <a
            v-if="!$isWebView()"
            class="el-button el-button--primary"
            type="info"
            tag="a"
            href="https://www.zapopan.gob.mx/v3/predial/oficinas-recaudadoras-municipales"
            target="_blank"
          >
            Ubicación de las recaudadoras
          </a>
          <a
            v-if="!$isWebView()"
            class="el-button el-button--primary"
            type="info"
            tag="a"
            href="https://pagos.zapopan.gob.mx/PagoEnLinea/"
          >
            Pagar predial
          </a>
        </div>
      </el-col>
    </el-col>
    <br />
    <br />
    <br />
    <el-footer class="hidden-xs-only">
      <el-row type="flex" justify="center">
        <el-col :xs="22" :sm="21" :md="20" :lg="19" :xl="18">
          <div class="banner">
          </div>
        </el-col>
      </el-row>
    </el-footer>
  </el-container>
</template>

<script>
// import imagesToBase64 from '../utils/account-status-qr-pdf/imagesToBase64';

const regExpPredial = new RegExp("impuesto", "i");
const regExpNotificacion = new RegExp("notificacion", "i");
const regExpGastoEjecucion = new RegExp("ACUDA", "i");
const regExpAlerta = new RegExp("ALERTA|CUENTA PRESENTA UN PAGO EN PROCESO", "i");
const regSinAdeudo = new RegExp("CUENTA NO TIENE ADEUDO", "i");
const regExp2003 = new RegExp("2003", "i");

export default {
  data() {
    /**
     * Valida que alguno de los 2 campos del formulario haya
     * sido ingresado. De lo contrario, regresa un error.
     */
    const orValidation = (val, rule, cb) => {
      const { accountNumber, curt } = this.form;
      const tempNumber =
        typeof accountNumber === "string" && accountNumber.trim()
          ? accountNumber.trim()
          : null;
      const tempCurt =
        typeof curt === "string" && curt.trim() ? curt.trim() : null;
      if (!(tempNumber || tempCurt)) {
        return cb(new Error("Debe llenar al menos uno de los campos."));
      }
      return cb();
    };
    return {
      showPrintReceiptBtn: false,
      receiptBtnLoading: false,
      reciboNuevoBtnLoading: false,
      certificateBtnLoading: false,
      loading: false,
      form: {
        accountNumber: null,
        curt: null,
      },
      tempForm: {
        accountNumber: null,
        curt: null,
      },
      rules: {
        accountNumber: [
          {
            pattern: /[0-9]$/,
            message: "El campo debe ser un valor numérico",
          },
          {
            min: 10,
            message: "El campo contener al menos 10 dígitos",
          },
          {
            validator: orValidation,
            trigger: "blur",
          },
        ],
        curt: [
          {
            pattern: /[0-9]$/,
            message: "El campo debe ser un valor numérico",
          },
          {
            min: 30,
            message: "El campo contener al menos 30 dígitos",
          },
          {
            validator: orValidation,
            trigger: "blur",
          },
        ],
      },
    };
  },
  methods: {
    //href="https://pagos.zapopan.gob.mx/PortalCiudadano/Recaudacion/RecaudoPredial.aspx"
    async goToReceipt() {
      
      return;
      try {
        this.receiptBtnLoading = true;
        const { accountNumber, curt } = this.tempForm;

        const param = accountNumber || curt;
        // const baseURL ='https://kioscos.zapopan.gob.mx:4443/verRecibo';
        const response = await this.axios.get(`/InformacionRecibo/${param}`);
        //const response = await this.axios.get(`${baseURL}/${param}`);
        
        const reciboPDF = response.data.recibo;
        if (reciboPDF && !response.data.alerta) {
          this.$store.dispatch("predio/SET_DATA", []);
          this.$store.dispatch("predio/SET_USER", {});
          this.$store.dispatch("receipt/SET_DATA", {
            reciboPDF,
            tipo: "pago-predial",
          });
          setTimeout(() => {
            this.$router.push({ path: "/recibo-pdf" });
          });
        }
      } catch (error) {
        this.$ErrorNotify(error);
      } finally {
        this.receiptBtnLoading = false;
      }
      
    },
    /**
     * Convierte y retorna los datos del usuario y predio provenientes del web service
     * a su tipo de dato equivalente en JavaScript para su mejor manejo.
     * @param {Object} data
     * @returns {Object}
     */
    normalizeUserFields(data) {
      return {
        pk: data.PREDIO.padronID || "",
        curt: data.PREDIO.curt || "",
        superficie_terreno: data.PREDIO.superficie_terreno,
        valor_de_la_construccion: parseFloat(
          data.PREDIO.valor_de_la_construccion
        ),
        valor_de_fiscal: parseFloat(data.PREDIO.valor_de_fiscal),
        superficie_construida: parseFloat(data.PREDIO.superficie_construida),
        cuentadepredial: data.PREDIO.cuentadepredial?.toString(),
        estatus_del_predio: data.PREDIO.estatus_del_predio,
        ubicacion: data.PREDIO.ubicacion,
        domicilio_fiscal: data.PREDIO.ubicacion,
        domicilio_notificacion: data.PREDIO.domicilio_notificacion,
        nombrecompletopropietario: data.PREDIO.nombrecompletopropietario,
        valor_del_terreno: parseFloat(data.PREDIO.valor_del_terreno),
        clave_catastral: data.PREDIO.clave_catastral,
        cargos: data.CARGOS,
        OPD: data.OPD,
        SEGURO: data.SEGURO,
        id_consulta: data.PREDIO.idConsulta
      };
    },
    /**
     * Convierte y retorna los datos de adeudos de predio provenientes del web service
     * a su tipo de dato equivalente en JavaScript para su mejor manejo.
     * @param {Object} data
     * @returns {Array}
     */
    normalizeDataFields(data) {
      //console.log('********** DATA PAGINA'+data);
      return data
        .map((cargo) => {
          const actualizacion = parseFloat(cargo.actualizacion);
          const recargo = parseFloat(cargo.recargo);

          const multasTotal = parseFloat(cargo.multas);

          const multa = parseFloat(cargo.multas);

          let pct_descuento = 0.5;
          const descday = new Date();
          const date1 = descday.getDate();
          const month = descday.getMonth() + 1;
          const year = descday.getFullYear();

          const descuentoMulta = parseFloat(cargo.TotalDescuentoMultasPorCargo);
          const descuentoMultaAplicable = parseFloat(
            cargo.TotalDescuentoMultasPorCargo
          );
          const descuentoSobreMultaAplicable = parseFloat(
            cargo.TotalDescuentoMultasPorCargo
          );

          /*
          const descuentoMulta = parseFloat(multa * pct_descuento);
          const descuentoMultaAplicable = parseFloat(multa * pct_descuento);
          const descuentoSobreMultaAplicable = parseFloat(
            multa * pct_descuento
          );
          */
          const descuentoRecargoBaseTotal = parseFloat(cargo.descuentoRecargos);
          const descuentoRecargo = parseFloat(cargo.descuentoRecargos);
          const descuentoAplicableSobreRecargo = parseFloat(
            cargo.descuentoRecargos
          );
          const pronto_pago = parseFloat(cargo.descProntoPago);
          // console.log('pronto_pago'+pronto_pago);

          const descuentoRecargoAplicable =
            typeof recargo !== "undefined"
              ? parseFloat(cargo.descuentoRecargos)
              : 0;

          const descuentoAplicable = 0;
          const descuentoBaseCargo = 0;
          let descuentoAplicableCargo =
            typeof cargo.descEspecial !== "undefined"
              ? parseFloat(cargo.descEspecial)
              : 0;
          const descuentoTerceraEdad =
            typeof cargo.descEspecial !== "undefined"
              ? parseFloat(cargo.descEspecial)
              : 0;
          descuentoAplicableCargo = descuentoAplicableCargo + pronto_pago;
          //console.log('DESCUENTO TERCERA EDAD '+descuentoTerceraEdad);

          let gasto = 0;
          let importe_base = 0;
          let descripcion = cargo.descripcion;

          gasto =
            parseFloat(cargo.gastosDeEjecucion) +
            parseFloat(cargo.gastosDeNotificacion);
          importe_base = parseFloat(cargo.impuestoBase);
          // cargos = cargo.multas.concat([{ cargoID: cargo.cargoID }])
          // .concat(cargo.gastosDeNotificacion).concat(cargo.gastosDeEjecucion).map((e) => e.cargoID);

          //}
          const cargos_id = cargo.cargoID;

          const adeudo =
            parseFloat(importe_base) +
            parseFloat(recargo) +
            parseFloat(gasto) +
            parseFloat(multa) +
            parseFloat(actualizacion);
          // console.log('******adeudo '+adeudo);
          const descuentoBase =
            parseFloat(descuentoRecargoAplicable) +
            parseFloat(descuentoMultaAplicable) +
            parseFloat(descuentoAplicableCargo);

          return {
            gasto,
            recargo,
            descuentoAplicable,
            gastosDeNotificacion: cargo.gastosDeNotificacion,
            gasto: gasto,
            gastosDeEjecucion: cargo.gastosDeEjecucion,
            descuentoBaseCargo,
            descuentoAplicableCargo,
            importe_base: importe_base,
            adeudo,
            multa,
            pronto_pago,
            observaciones: descripcion,
            descuentoRecargo: descuentoRecargoBaseTotal,
            descuentoTerceraEdad: descuentoTerceraEdad,
            descuentoRecargoAplicable: descuentoRecargoAplicable,
            // recargos_corriente: parseFloat(cargo.recargosCorriente),
            recargos_corriente: parseFloat(cargo.recago),
            recargosEjercicioAnterior: parseFloat(
              cargo.recargosEjercicioAnterior
            ),
            actualizacion,
            descuentoMulta,
            descuentoMultaAplicable,
            cargos: cargos_id,
            checked: true,
            disabled: false,
            descuentoBase,
            // descuentoAplicableSobreRecargo: cargo.descuentoAplicableSobreRecargo,
            descuentoAplicableSobreRecargo: descuentoAplicableSobreRecargo,
            // descuentoAplicableArr: cargo.descuentoAplicable,
            descuentoAplicableArr: descuentoAplicable,
            //
            descuentoSobreMultaAplicable: descuentoSobreMultaAplicable,
          };
        })
        .sort((a, b) => {
          if (
            regExpNotificacion.test(a.observaciones) &&
            regExpNotificacion.test(b.observaciones) &&
            a.observaciones < b.observaciones
          ) {
            return 1;
          }
          /*
            if (regExpGastoEjecucion.test(a.observaciones)) {
              return 1;
            }
          
          if (
            regExpPredial.test(a.observaciones) &&
            regExpPredial.test(b.observaciones)
          ) {
            return 0;
          }

          if (regExpPredial.test(a.observaciones)) {
            return 1;
          }
          return 1;
          */

          if (
            regExpPredial.test(a.observaciones) &&
            regExpPredial.test(b.observaciones) &&
            a.observaciones < b.observaciones
          ) {
            return -1;
          }
          // if (regExpPredial.test(a.observaciones)) {
          if (a.observaciones > b.observaciones) {
            return 1;
          }

          return 0;
        });
    },
    /**
     * Controla el envío del formulario.
     * Revisa que las reglas aplicadas pasen y de
     * ser cierto ejecuta la búsqueda. De lo contrario,
     * muestra al usuario los errores o reglas no pasadas.
     */
    beforeSubmit() {
      return new Promise((resolve) => {
        this.$refs.form.validate(resolve);
      });
    },
    /**
     * Busca la información de un predio.
     * Si lo encuentra, guardará la información de este
     * en el estado global de la aplicación y redireccionará
     * al usuario a la página de resumen de adeudo.
     * De lo contrario, mostrará una alerta al usuario.
     */
    async submit() {
      try {
        const valid = await this.beforeSubmit();
        if (valid) {
          this.loading = true;
          this.showPrintReceiptBtn = false;
          this.$store.dispatch("receipt/SET_DATA", {});
          this.$store.dispatch("certificate/CLEAR_DATA", {});
          const param = this.form.accountNumber
            ? this.form.accountNumber
            : this.form.curt;
          //const baseURL1 = "https://pagos.zapopan.gob.mx/sir_Api/api/";
          //const baseURL = 'https://pruebasigob.zapopan.gob.mx/WSCsOBRO/API_PagoEnLinea/api/';
          // const baseURL = 'https://351a91ebc2bb.ngrok.io/api/get_by_cuenta';
          //const baseURL1 = "https://indicadores.zapopan.gob.mx:8080/pago-en-linea-pruebas/predio/get_by_cuenta";
          const baseURL1 = "https://indicadores.zapopan.gob.mx:8080/pago-en-linea/predio/get_by_cuenta";
          //const baseURL =
          //  "https://kioscos.zapopan.gob.mx:8080/pago-en-linea/api/get_by_cuenta";
          //const baseURL = "https://indicadores.zapopan.gob.mx:8080/pago-en-linea-pruebas/api/get_by_cuenta";
          const baseURL = "https://indicadores.zapopan.gob.mx:8080/pago-en-linea/api/get_by_cuenta";
          // const baseURL = 'http://localhost/sir_api/api/';
          // const baseURL = 'http://localhost:50672/api/AdeudoPredialPagoEnLinea/';
          this.axios.interceptors.response.use((resp) => {
            let v = resp.headers["vers"] || "default";
            if (
              v !== localStorage.getItem("vers") &&
              resp.config.method == "get"
            ) {
              localStorage.setItem("vers", v);
              window.location.reload(); // For new version, simply reload on any get
            }
            return Promise.resolve(resp);
          });

          const response_predio = await this.axios.get(`${baseURL1}/${param}`);

          const predio = response_predio.data;
          //console.log(predio);
          if (predio) {

            if (predio.PREDIO.alertaGastos != "") {
            this.$ErrorNotify({
                response: {
                  data: {
                    alerta: predio.PREDIO.alertaGastos,
                  },
                },
            });            
            return;
            }

            const response_cargos = await fetch(`${baseURL}/${param}`);
            const cargos = await response_cargos.json();
            // console.log(response_cargos);
            console.log("*********CARGOS");
            console.log(cargos);
            console.log("*********PREDIO");
            console.log(predio);
            const fields = this.normalizeDataFields(cargos);
            console.log("predio alerta gastos");
            console.log(predio.PREDIO.alertaGastos);
            console.log("*********OPD");
            console.log(predio.OPD);
            console.log(
              "valor del terreno" + parseFloat(predio.PREDIO.valor_del_terreno)
            );

            if(fields.some((x) => x.descuentoBase>=x.adeudo)
            &&fields.some((x) => x.adeudo=0)
            ){
              this.$ErrorNotify({
                response: {
                  data: {
                    alerta: 'El monto debe ser verificado en recaudadora',
                  },
                },
              });
              return;
            } else 
            if (
              regExpAlerta.test(predio.PREDIO.alertaGastos) ||
              regSinAdeudo.test(predio.PREDIO.alertaGastos) ||
              regExpGastoEjecucion.test(predio.PREDIO.alertaGastos)
            ) {
              this.showPrintReceiptBtn = true;
              this.tempForm = {
                ...this.form,
              };
              this.$ErrorNotify({
                response: {
                  data: {
                    alerta: predio.PREDIO.alertaGastos,
                  },
                },
              });
            } else if (
              !fields.some((x) => regExpPredial.test(x.observaciones))
            ) {
              this.showPrintReceiptBtn = true;
              this.tempForm = {
                ...this.form,
              };
              this.$ErrorNotify({
                response: {
                  data: {
                    alerta: "El predio no contiene cargos con adeudo.",
                  },
                },
              });
            } /* else if (
              fields.some((x) => regExpNotificacion.test(x.observaciones))
            ) {
              this.showPrintReceiptBtn = true;
              this.tempForm = {
                ...this.form,
              };
              this.$ErrorNotify({
                response: {
                  data: {
                    alerta:
                      "El predio tiene notificaciones por rezago, acuda a la recaudadora",
                  },
                },
              });
            } else if (regExpNotificacion.test(predio.observaciones)) {
              this.showPrintReceiptBtn = true;
              this.tempForm = {
                ...this.form,
              };
              this.$ErrorNotify({
                response: {
                  data: {
                    alerta:
                      "El predio tiene notificaciones por rezago, acuda a la recaudadora",
                  },
                },
              });
            } else if (
              fields.some((x) => regExpGastoEjecucion.test(x.observaciones))
            ) {
              this.showPrintReceiptBtn = true;
              this.tempForm = {
                ...this.form,
              };
              this.$ErrorNotify({
                response: {
                  data: {
                    alerta:
                      "El predio tiene gastos por apremios acuda a la recaudadora",
                  },
                },
              });
            } else if (regExpGastoEjecucion.test(predio.observaciones)) {
              this.showPrintReceiptBtn = true;
              this.tempForm = {
                ...this.form,
              };
              this.$ErrorNotify({
                response: {
                  data: {
                    alerta:
                      "El predio tiene gastos por apremios acuda a la recaudadora",
                  },
                },
              });
            } */ else if (
              regExpAlerta.test(predio.PREDIO.alertaGastos) ||
              regSinAdeudo.test(predio.PREDIO.alertaGastos)
            ) {
              this.showPrintReceiptBtn = true;
              this.tempForm = {
                ...this.form,
              };
              this.$ErrorNotify({
                response: {
                  data: {
                    alerta: predio.PREDIO.alertaGastos,
                  },
                },
              });
            } else {
              const user = this.normalizeUserFields(predio);
              console.log("NORMALIZANDO CAMPOS");
              console.log(predio);
              console.log(user);
              this.$store.dispatch("predio/SET_USER", user);
              this.$store.dispatch("predio/SET_DATA", fields);
              setTimeout(() => {
                this.$router.push({ path: "resumen-de-adeudo" });
              });
            }
          } else if (data?.descripcion) {
            const { descripcion } = data;
            if (
              descripcion.toLowerCase() ===
              "el predio no contiene cargos con adeudo."
            ) {
              this.showPrintReceiptBtn = true;
              this.tempForm = {
                ...this.form,
              };
            }
            this.$ErrorNotify({
              response: {
                data: {
                  alerta: descripcion,
                },
              },
            });
          }
        }
      } catch (error) {
        this.$ErrorNotify(error);
      } finally {
        this.loading = false;
      }
    },
    /**
     * JEO
     */
    async UltimoReciboSubmit() {
      const valid = await this.beforeSubmit();
      if (valid) {
        this.reciboNuevoBtnLoading = true;
        const { accountNumber, curt } = this.form;
        const cuenta = accountNumber !== null ? accountNumber : curt;
        //window.location.href = 'https://kioscos.zapopan.gob.mx:4443/verRecibo/' + cuenta;
        //await this.axios.get(`https://kioscos.zapopan.gob.mx:4443/verRecibo/${cuenta}`)
        await this.axios.get(`https://wspredial.zapopan.gob.mx/verRecibo/${cuenta}`)
        .then(response => {

          this.$ErrorNotify({
                  response: {
                    data: {
                      alerta: "Buscar en sus descargas",
                    },
                  },
              });

          const downloadLink = document.createElement("a");
          downloadLink.href = `data:application/pdf;base64,${response.data}`;
          downloadLink.download = `Recibo ${cuenta}.pdf`;
          downloadLink.click();

          reciboNuevoBtnLoading = false;
        })
        .catch(error => {
            this.reciboNuevoBtnLoading = false;
            if (error.response)
              this.$ErrorNotify({
                  response: {
                    data: {
                      alerta: error.response.data,
                    },
                  },
              });
        });
      }
    },
    /**
     * Verifica que la cuenta predial pueda imprimir la
     * constancia de no adeudo y lo envía a la pantalla de pago
     * para imprimirla. De lo contrario, mostrará una alerta al usuario.
     */
    async noDebtsCertificateSubmit() {
      try {
        const valid = await this.beforeSubmit();
        if (valid) {
          const { accountNumber, curt } = this.form;
          //console.log('curt '+curt);
          const cuenta = accountNumber !== null ? accountNumber : 0;
          //console.log('accountNumber '+cuenta);

          this.certificateBtnLoading = true;
          let response = null;
          if (cuenta > 0) {
            response = await this.axios("/validacionconstancianoadeudo", {
              params: {
                cuenta_predial: cuenta,
              },
            });
          } else {
            response = await this.axios("/validacionconstancianoadeudo", {
              params: {
                curt: curt,
              },
            });

            /*alert(
              "No puede generar constancia con la CURT, por favor acudir a la recaudadora"
            );
            return;*/
          }

          const { data } = response;
          if (data && !data.alerta) {
            this.$store.dispatch("certificate/SET_DATA", { ...data });
            setTimeout(() => {
              this.$router.push({ path: "pagar-constancia" });
            });
          } else {
            await this.$ErrorNotify({ response });
            //this.submit();
          }
        }
      } catch (err) {
        this.$ErrorNotify(err);
      } finally {
        this.certificateBtnLoading = false;
      }
    },
  },
  /**
   * Limpia al estado global de la aplicación
   * al entrar a la página.
   */
  created() {
    this.$store.dispatch("predio/SET_DATA", []);
    this.$store.dispatch("predio/SET_USER", {});
    this.$store.dispatch("predio/SET_RECIBO", null);
    this.$store.dispatch("receipt/SET_DATA", {});
    this.$store.dispatch("cart/CLEAR_DATA");
    this.$store.dispatch("certificate/CLEAR_DATA");
    this.$store.dispatch("avaluos/CLEAR_DATA");
    // Uncomment to generate base64 files for imagen in account status
    // imagesToBase64();
  },
};
</script>

<style lang="scss" scoped>
#search-screen {
  .main-wrapper {
    .left-wrapper {
      .form {
        .form-title {
          color: #330066;
          font-size: 16pt;
          font-weight: bold;
          font-family: Tahoma;
        }
        .el-form-item__label {
          display: flex;
          flex-direction: column;
          align-items: flex-start;
          justify-content: flex-start;
          text-align: left;
          .main {
            color: Black;
            font-size: 14pt;
            line-height: 26px;
            font-weight: bold;
            font-family: "HelveticaNeue" !important;
            font-weight: bold !important;
          }
          .clue {
            line-height: 26px;
            padding: 0px !important;
            margin: 0px !important;
            color: graytext;
            font-size: 14pt;
            font-family: "HelveticaNeue" !important;
            font-weight: bold !important;
          }
        }

        .el-input {
          margin-top: 5px;
        }
        #btn-submit {
          font-family: Arial;
          font-size: 12pt;
          font-weight: bold;
          cursor: pointer;
        }
      }
      .schedule {
        color: rgba(0, 0, 0, 0.247);
        font-family: Arial;
        font-size: 10pt;
        font-weight: normal;
      }
    }
    .right-wrapper {
      display: flex;
      flex-direction: column;
      justify-content: center;
      height: 100%;
      .logo {
        position: relative;
        height: 120px;
        overflow: hidden;
        img {
          height: 100%;
          object-fit: contain;
        }
      }
      .actions-wrapper {
        margin: 10px 0px;
        .el-button {
          display: block;
          font-family: Arial;
          font-size: 10pt;
          font-weight: bold;
          text-decoration: none;
          margin: 10px 0px;
          margin-left: 0px !important;
        }
      }
      .print-badge {
        text-align: right;
        float: right;
        img {
          max-width: 100%;
        }
      }
    }
  }
  .el-footer {
    height: auto !important;
    .banner {
      width: 100%;
      overflow: hidden;
      img {
        height: 100%;
        width: 100%;
        object-fit: contain;
      }
    }
  }
  @media screen and (min-width: 768px) {
    #btn-no-debts-certificate {
      br {
        display: none !important;
      }
    }
    .right-wrapper {
      float: right;
    }
  }
  @media screen and (max-width: 768px) {
    .right-wrapper {
      height: auto !important;
      .el-button {
        display: -webkit-box;
        text-overflow: ellipsis;
        white-space: nowrap;
        overflow: hidden;
        white-space: nowrap;
        width: 100%;
      }
    }
  }
}
</style>
